import { observer } from 'mobx-react-lite'
import { useState } from 'react'
import { KeywordsTable } from '../components/keywords/KeywordsTable'
import { ExpandedPerformanceMetrics } from '../components/table2/ad_grid_columns'
import { TableStore } from '../components/table2/table_store'
import { useSavedFiltersStore } from '../hooks/useSavedFiltersStore'
import { useUser } from '../hooks/useUser'
import { useTableHooksFromStore } from '../packages/blueprint-components/src/useTableHooks'
import { userStore } from '../stores/user_store'
import { Keyword } from '../types/keyword'
import { adManagerPerformanceGet } from '../util/adManagerPerformanceApi'

export const Keywords = observer(() => {
    const { profile } = useUser()
    const [store] = useState(
        new TableStore<Keyword & ExpandedPerformanceMetrics>(userStore, 'keywords'),
    )
    const savedFiltersStore = useSavedFiltersStore()

    const load = (params: any) => {
        if (!profile) {
            return Promise.resolve()
        }

        return adManagerPerformanceGet('api/v5/keywords', params, true)
    }

    const tableHooks = useTableHooksFromStore(load, {}, false, store)

    return (
        <>
            <KeywordsTable
                store={store}
                savedFiltersStore={savedFiltersStore}
                tableHooks={tableHooks}
            />
        </>
    )
})
